import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AxiosClient from "../../../../_helpers/http.helper";
import flag from "../../../../assets/flag.png";
import urlHelper from "../../../../_helpers/url.format.server.helper";
import config from "../../../../config";
import { PERMISSIONS } from "../../../constants/constants";

export default class PdfLink extends Component {
    static get propTypes() {
        return {
            totalPdfs: PropTypes.array.isRequired,
            pdfs: PropTypes.array.isRequired,
            getPdfs: PropTypes.func.isRequired,
            collectionId: PropTypes.string.isRequired,
            handlePitStopStatus : PropTypes.func.isRequired
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            pdfLinksPolledCount: 0,
            pitStopStatus:{
                "MergedCoverPageWithBarCode": null,
                "PrintBook": null
            }
        };
        this.pdfLinksTimeout = null;
    }

    componentDidMount() {
        this.props.getPdfs();
        this.getPitStopStatus();
    }

    getPitStopStatus = () => {
        let url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.pitStopStatus,
            {
                collectionId: this.props.collectionId
            }
        );
        AxiosClient.get(url).then(result => {
            this.setState({
                ...this.state,
                pitStopStatus: result.data
            });
            this.props.handlePitStopStatus(this.state.pitStopStatus);
        }).catch(() => {
            this.setState({
                ...this.state,
                pitStopStatus:{
                    "MergedCoverPageWithBarCode": null,
                    "PrintBook": null
                }
            });
            this.props.handlePitStopStatus(this.state.pitStopStatus);
        });
    };

    componentWillReceiveProps(nextProps){
        if (this.props.pdfs !== nextProps.pdfs) {
            const isEpsUploadPending = nextProps.pdfs.find((pdfLink) => pdfLink.isEPSUploaded === false);
            if (isEpsUploadPending && this.state.pdfLinksPolledCount < 50 && !nextProps.pdfs.isFetching) {
                this.pollForPdfLinks();
            } else {
                clearTimeout(this.pdfLinksTimeout);
                this.props.getDRVS(this.props.collectionId);
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.pdfLinksTimeout);
    }

    render() {
        const CustomPdfArray = this.props.totalPdfs.filter(item => item.contentSource === "Custom");
        let customFrontMatter = false;
        const userRolePermissions = this.props.permissions;
        const { pdfs } = this.props;
        if( CustomPdfArray.find(element => element.printPageType === "CustomTitlePage" || element.printPageType === "CustomCopyrightPage")!= null){
            customFrontMatter = true;
        }
        return (
            <div className="book-details-pdf-links-wrapper">
                {this.props.pdfs && pdfs && pdfs.map(
                    pdfDetail => (
                        <div>
                            {(!userRolePermissions.includes(PERMISSIONS.hide_only_pdflinks) || (pdfDetail.printPageType !== 'Content' && pdfDetail.printPageType !== 'Full Book Content')) && <div key={pdfDetail.id} className="book-details-pdf-link">
                                <div className="link-content">
                                    <div>
                                        <img src="/printadmin/images/pdf.png" alt="PDF Icon" />
                                    </div>
                                    <div>
                                        {(pdfDetail.isEPSUploaded) ?
                                            <div className="pdf-details">
                                                <a href={pdfDetail.contentUrl} target="_blank">{pdfDetail.printPageType}&nbsp;</a>
                                                {(pdfDetail.contentSource === 'Custom' && pdfDetail.printPageType !== "Front Matter") ?
                                                    <img className="flag-image" src={flag}/> : ""}
                                                {(pdfDetail.printPageType === "Front Matter" && (customFrontMatter || pdfDetail.contentSource === 'Custom'))  ?
                                                    <img className="flag-image" src={flag}/> : ""}
                                                <div className="pitStop-status">
                                                    {(this.state.pitStopStatus.PrintBook !== null && this.state.pitStopStatus.PrintBook !== undefined && pdfDetail.printPageType === "Full Book Content") ? this.state.pitStopStatus.PrintBook.detailedStatusMessage : ""}
                                                    {(this.state.pitStopStatus.MergedCoverPageWithBarCode !== null && this.state.pitStopStatus.MergedCoverPageWithBarCode !== undefined && pdfDetail.printPageType === "Cover") ? this.state.pitStopStatus.MergedCoverPageWithBarCode.detailedStatusMessage :  ""}
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                <span>{pdfDetail.printPageType}</span>
                                                <span>(Pending)</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>}
                        </div>
                    )
                )}
            </div>
        );
    }

    pollForPdfLinks() {
        this.setState(prevState => {
            return { pdfLinksPolledCount: prevState.pdfLinksPolledCount + 1 };
        });

        this.pdfLinksTimeout = setTimeout(this.props.getPdfs, 10000);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerComponents/PdfLink.js